import { Component, OnInit } from '@angular/core';
import { Practice } from 'src/app/models/practice';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public fieldLabel:string='New Practice Image';

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute,
    private _notify: NotificationService
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        if(this.practice.media) this.practice.media.url=environment.apiEndpoint+'/storage/practices/'+this.practice.media.url;
        this.loadedPractice=true;
      }
    );
  }

  public getImageData(imageData:any){
    this.practice.newImageB64=imageData[1];
    this.practice.newImageType=imageData[0];
  }

  public updatePractice(){
    if(this.practice.name=='') return this._notify.showMessage('Practice must have a title', 'OK');
    this._practice.updatePractice(this.practice).subscribe(
      res=>{
        this.getPractice();
        this._notify.showMessage('Practice updated.', 'OK');
      }
    );
  }

  ngOnInit() {
    this.getPractice();
  }

}
